import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { PatchInfo } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import PatchInfoPanel from './patch-info-panel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'patch-popover',
  props: {
  patchInfo: {
    type: Object as PropType<PatchInfo>,
    default: () => ({} as PatchInfo)
  },
  warnLevel: {
    type: Number
  },
  placement: {
    type: String,
    default: 'right'
  },
  descriptionFallback: {
    type: String,
    default: ''
  },
  pubDateFallback: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: __props.placement,
    width: 380,
    trigger: "hover"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createVNode(PatchInfoPanel, {
        "patch-info": __props.patchInfo,
        "warn-level": __props.warnLevel,
        "description-fallback": __props.descriptionFallback,
        "pub-date-fallback": __props.pubDateFallback
      }, null, 8, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
    ]),
    _: 3
  }, 8, ["placement"]))
}
}

})